import { render, staticRenderFns } from "./AiQuestionaryView.vue?vue&type=template&id=f84c0774&"
import script from "./AiQuestionaryView.vue?vue&type=script&lang=ts&"
export * from "./AiQuestionaryView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports